// ============================================================================
// MARTELLI RENTALS — Contenuti centralizzati (unico punto di modifica)
// Modifica testi, strutture, prezzi, servizi e contatti solo da questo file.
// ============================================================================

// TODO: Add the official WhatsApp number if it changes
export const CONTACT = {
  email: "martellirentals@gmail.com",
  instagram: "martellirentals",
  instagramUrl: "https://www.instagram.com/martellirentals/",
  whatsappNumber: "+393473724352", // usato per link wa.me
};

// ---- Booking engine: configurazione (predisposto per provider reali) ----
// Valori: "native" | "iframe" | "external-link" | "api"
export const BOOKING_ENGINE_MODE = "native";
export const BOOKING_ENGINE_CONFIG = {
  provider: "TO_BE_DEFINED", // Smoobu | Beds24 | Vikey | Lodgify | WuBook ...
  iframeUrl: "",
  externalBookingUrl: "",
  apiBaseUrl: "",
  apiKey: "", // NON inserire mai chiavi reali nel frontend — usa il backend
};

export const AMENITY_LABELS = {
  pool: "Piscina",
  mountainView: "Vista montagna",
  garden: "Giardino",
  breakfast: "Colazione",
  parking: "Parcheggio",
  wifi: "Wi-Fi",
  outdoor: "Spazi esterni",
  relax: "Area relax",
  central: "Posizione centrale",
  ac: "Aria condizionata",
  smartTv: "Smart TV",
  privateBath: "Bagno privato",
  living: "Zona soggiorno",
  selfCheckin: "Self check-in",
  support: "Assistenza ospiti",
  kitchen: "Cucina",
  washer: "Lavatrice",
  petFriendly: "Pet-friendly",
  loft: "Soppalco",
  historic: "Centro storico",
};

// ---- STRUTTURE ----
// TODO: Replace placeholder images with original photos
// ✅ LA TERRA DI GAIA: foto reali inserite (piscina/Monte Velino, drone, camera king, colazioni).
// ✅ APPARTAMENTO CORRIDONI: foto reali inserite (open space, camere, soggiorno, cucina).
// ✅ AL DUOMO: foto reali inserite (vista Piazza Duomo come principale, soggiorno, sala, cucina, camera soppalco).
// ✅ HOMAS ROMA: foto reali inserite (sala da pranzo come principale, soggiorno, camera, angolo cottura, bagno).
// ✅ COSTA MASCIARELLI: foto reali inserite (Imperial Suite come principale, Exclusive, Prestige, affresco).
// ✅ LA BRIGANTESSA: foto reale inserita (soggiorno/cucina). Altre foto da aggiungere quando disponibili.
// 🎉 Tutte le 6 strutture usano ora fotografie reali.
export const properties = [
  {
    id: "p1",
    slug: "la-terra-di-gaia",
    name: "La Terra di Gaia",
    city: "Magliano de’ Marsi",
    region: "Abruzzo",
    country: "Italia",
    type: "Villa con piscina · camere e villa intera",
    category: "villa",
    cin: "IT066053B5GWPQ8U6T",
    shortDescription:
      "Una villa immersa nella natura, con piscina e vista sul paesaggio montano, ai piedi del Monte Velino.",
    longDescription:
      "La Terra di Gaia è una villa accogliente circondata dalla natura, pensata per chi desidera rallentare e vivere l’Abruzzo in modo autentico. La struttura dispone di piscina, spazi esterni e camere curate, con una vista aperta sulle montagne e sul giardino.",
    maxGuests: 6,
    bedrooms: 2,
    bathrooms: 2,
    sizeSqm: null,
    rooms: ["Camera King con vista giardino", "Camera King con vista montagna", "Possibilità di configurazione familiare"],
    amenities: ["pool", "mountainView", "garden", "breakfast", "parking", "wifi", "outdoor", "relax"],
    tags: ["Villa con piscina", "Abruzzo", "Monte Velino"],
    badge: "Villa con piscina",
    featuredImage: "/images/properties/la-terra-di-gaia/terra-di-gaia-piscina-monte-velino.webp",
    gallery: [
      "/images/properties/la-terra-di-gaia/terra-di-gaia-piscina-monte-velino.webp",
      "/images/properties/la-terra-di-gaia/terra-di-gaia-vista-drone.webp",
      "/images/properties/la-terra-di-gaia/terra-di-gaia-camera-king-vista-montagna.webp",
      "/images/properties/la-terra-di-gaia/terra-di-gaia-colazione-giardino-monte-velino.webp",
      "/images/properties/la-terra-di-gaia/terra-di-gaia-sala-colazione.webp",
    ],
    startingPrice: 180,
    currency: "EUR",
    bookingUrl: "",
    featured: true,
    active: true,
    villaBadge: "Villa intera da giugno 2027",
    extras: ["breakfast", "poolAccess", "cleaning", "petFee"],
  },
  {
    id: "p2",
    slug: "costa-masciarelli",
    name: "Costa Masciarelli",
    city: "L’Aquila",
    region: "Abruzzo",
    country: "Italia",
    type: "Boutique B&B · 3 suite indipendenti",
    category: "bnb",
    cin: "",
    shortDescription: "Tre eleganti suite indipendenti nel cuore del centro storico dell’Aquila, a circa 3 minuti da Piazza Duomo.",
    longDescription:
      "B&B Costa Masciarelli propone tre suite raffinate nel cuore del centro storico dell’Aquila, a circa tre minuti a piedi da Piazza Duomo. Ogni ambiente conserva un carattere distinto, tra soffitti affrescati, pavimenti in marmo, travi in legno e dettagli architettonici di pregio. Le suite — Imperial, Exclusive e Privilege — offrono comfort, eleganza e autonomia. Colazione non disponibile.",
    maxGuests: 4,
    bedrooms: 3,
    bathrooms: 3,
    sizeSqm: 43,
    rooms: ["Imperial Suite · 43 m²", "Exclusive Suite · 37 m²", "Privilege Suite · 34 m²"],
    amenities: ["central", "wifi", "ac", "smartTv", "privateBath", "living", "selfCheckin", "support"],
    tags: ["Centro storico", "L’Aquila", "Abruzzo"],
    badge: "Centro storico",
    featuredImage: "/images/properties/costa-masciarelli/costa-masciarelli-imperial-suite.webp",
    gallery: [
      "/images/properties/costa-masciarelli/costa-masciarelli-imperial-suite.webp",
      "/images/properties/costa-masciarelli/costa-masciarelli-exclusive-suite.webp",
      "/images/properties/costa-masciarelli/costa-masciarelli-privilege-suite.webp",
      "/images/properties/costa-masciarelli/costa-masciarelli-affresco-imperial-suite.webp",
    ],
    startingPrice: 95,
    currency: "EUR",
    featured: true,
    active: true,
    extras: ["breakfast", "lateCheckout", "cleaning"],
  },
  {
    id: "p3",
    slug: "la-brigantessa-apartment",
    name: "La Brigantessa Apartment",
    city: "Valdevarri",
    region: "Abruzzo",
    country: "Italia",
    type: "Intera casa su due livelli",
    category: "apartment",
    cin: "IT066089C29SFOOXZI",
    cir: "066096CVP0008",
    shortDescription:
      "Casa accogliente su due livelli tra i monti d’Abruzzo, con camino, cucina attrezzata, barbecue e parcheggio gratuito.",
    longDescription:
      "La Brigantessa è una casa calda e silenziosa su due livelli, situata a circa 1.000 metri di altitudine nel borgo di Valdevarri. È pensata per chi desidera rallentare, vivere la montagna e scoprire borghi, sentieri e panorami autentici dell’Abruzzo. L’alloggio può ospitare fino a cinque persone e dispone di soggiorno con camino, cucina attrezzata, camera matrimoniale, letto a castello, divano letto, bagno, lavatrice e spazi esterni con barbecue e zona pranzo. Su richiesta sono disponibili cene tipiche preparate con prodotti locali.",
    maxGuests: 5,
    bedrooms: 1,
    bathrooms: 1,
    sizeSqm: null,
    rooms: ["Camera matrimoniale", "Letto a castello", "Divano letto", "Soggiorno con camino"],
    amenities: ["wifi", "kitchen", "living", "parking", "outdoor", "petFriendly"],
    tags: ["Digital detox", "Borgo", "Abruzzo"],
    badge: "Digital detox",
    highlight: "Un soggiorno digital detox tra i monti d’Abruzzo: tranquillità, silenzio e ritmi lenti. Il Wi-Fi è comunque disponibile.",
    featuredImage: "/images/properties/la-brigantessa-apartment/la-brigantessa-soggiorno-cucina.webp",
    gallery: [
      "/images/properties/la-brigantessa-apartment/la-brigantessa-soggiorno-cucina.webp",
      "/images/properties/la-brigantessa-apartment/la-brigantessa-c.webp",
      "/images/properties/la-brigantessa-apartment/la-brigantessa-d.webp",
      "/images/properties/la-brigantessa-apartment/la-brigantessa-b.webp",
    ],
    captions: ["Zona pranzo", "Camera matrimoniale", "Cucina attrezzata", "Esterno della casa"],
    startingPrice: 110,
    currency: "EUR",
    featured: false,
    active: true,
    extras: ["cleaning", "petFee"],
  },
  {
    id: "p4",
    slug: "appartamento-corridoni",
    name: "Dimora Corridoni",
    city: "L’Aquila",
    region: "Abruzzo",
    country: "Italia",
    type: "Intero appartamento",
    category: "apartment",
    cin: "IT066049C2Z2BTY7TS",
    shortDescription:
      "Appartamento accogliente e funzionale nel centro dell’Aquila, con due camere, balcone e parcheggio gratuito in strada.",
    longDescription:
      "Dimora Corridoni è un appartamento luminoso e funzionale, ideale per coppie, famiglie o piccoli gruppi che desiderano soggiornare vicino al centro dell’Aquila senza rinunciare alla tranquillità e alla comodità dell’auto. L’alloggio può ospitare fino a quattro persone e dispone di soggiorno, cucina attrezzata, camera matrimoniale, camera doppia, bagno e balcone privato. Piazza Duomo è raggiungibile in circa otto minuti a piedi, la Basilica di Collemaggio in cinque minuti e la Fontana Luminosa in circa tredici minuti.",
    maxGuests: 4,
    bedrooms: 2,
    bathrooms: 1,
    sizeSqm: null,
    rooms: ["Camera matrimoniale", "Camera con 2 letti singoli unibili", "Soggiorno con cucina"],
    amenities: ["kitchen", "living", "wifi", "smartTv", "parking", "selfCheckin", "mountainView"],
    tags: ["Appartamento indipendente", "L’Aquila", "Abruzzo"],
    badge: "Appartamento indipendente",
    featuredImage: "/images/properties/appartamento-corridoni/corridoni-soggiorno-open-space.webp",
    gallery: [
      "/images/properties/appartamento-corridoni/corridoni-soggiorno-open-space.webp",
      "/images/properties/appartamento-corridoni/corridoni-camera-matrimoniale.webp",
      "/images/properties/appartamento-corridoni/corridoni-soggiorno-divano.webp",
      "/images/properties/appartamento-corridoni/corridoni-camera-doppia.webp",
      "/images/properties/appartamento-corridoni/corridoni-cucina.webp",
    ],
    captions: ["Soggiorno luminoso", "Camera matrimoniale", "Zona relax con Smart TV", "Camera con due letti singoli", "Cucina attrezzata"],
    startingPrice: 85,
    currency: "EUR",
    featured: false,
    active: true,
    extras: ["cleaning", "lateCheckout"],
  },
  {
    id: "p5",
    slug: "appartamento-duomo",
    name: "Appartamento al Duomo",
    city: "L’Aquila",
    region: "Abruzzo",
    country: "Italia",
    type: "Intero appartamento su due livelli",
    category: "apartment",
    cin: "IT066049C2HFYX6F4G",
    shortDescription:
      "Appartamento su due livelli con balconi affacciati direttamente su Piazza Duomo, nel cuore del centro storico dell’Aquila.",
    longDescription:
      "Un appartamento unico con balconi direttamente affacciati su Piazza Duomo, nel punto più centrale del centro storico dell’Aquila. Gli ambienti sono ampi e luminosi e consentono di vivere la città interamente a piedi, con ristoranti, bar, negozi e monumenti immediatamente sotto casa. L’alloggio si sviluppa su due livelli e dispone di soggiorno con Smart TV, cucina attrezzata, camera matrimoniale, spazio aggiuntivo con letto singolo, due divani letto e due bagni completi. Dai balconi privati si gode di una vista aperta sulla piazza, sul centro storico e sulle montagne.",
    maxGuests: 6,
    bedrooms: 1,
    bathrooms: 2,
    sizeSqm: 60,
    rooms: ["Camera matrimoniale", "Spazio aperto con letto singolo", "2 divani letto", "Soppalco · 2 bagni"],
    amenities: ["kitchen", "wifi", "smartTv", "loft", "ac", "selfCheckin", "central"],
    tags: ["Vicino al Duomo", "L’Aquila", "Abruzzo"],
    badge: "Vicino al Duomo",
    featuredImage: "/images/properties/appartamento-duomo/al-duomo-vista-piazza-duomo.webp",
    gallery: [
      "/images/properties/appartamento-duomo/al-duomo-vista-piazza-duomo.webp",
      "/images/properties/appartamento-duomo/al-duomo-soggiorno.webp",
      "/images/properties/appartamento-duomo/al-duomo-sala-pranzo-balcone.webp",
      "/images/properties/appartamento-duomo/al-duomo-cucina.webp",
      "/images/properties/appartamento-duomo/al-duomo-camera-soppalco.webp",
    ],
    startingPrice: 105,
    currency: "EUR",
    featured: true,
    active: true,
    extras: ["breakfast", "lateCheckout", "cleaning"],
  },
  {
    id: "p6",
    slug: "homas-roma",
    name: "Homas Roma",
    city: "Roma",
    region: "Lazio",
    country: "Italia",
    type: "Intero appartamento",
    category: "apartment",
    cin: "IT058091C26MA8VQ7T",
    shortDescription: "Appartamento accogliente a Città Giardino, vicino alla Metro B e a circa 15 minuti dal centro di Roma.",
    longDescription:
      "Homas Roma è un appartamento caldo e accogliente nel quartiere Città Giardino, a pochi passi da Piazza Sempione e ben collegato con il centro attraverso la Metro B, le stazioni Tiburtina e Nomentana e diverse linee autobus. L’alloggio dispone di una camera matrimoniale, soggiorno con angolo cottura e divano letto matrimoniale, bagno e piccolo spazio esterno privato. È adatto a coppie, famiglie, piccoli gruppi e ospiti che viaggiano con animali domestici.",
    maxGuests: 4,
    bedrooms: 1,
    bathrooms: 1,
    sizeSqm: null,
    rooms: ["Camera matrimoniale", "Divano letto matrimoniale", "Soggiorno con angolo cottura"],
    amenities: ["kitchen", "wifi", "washer", "outdoor", "parking", "petFriendly", "support"],
    tags: ["Roma", "Lazio", "Città Giardino"],
    badge: "Roma",
    featuredImage: "/images/properties/homas-roma/homas-roma-sala-da-pranzo.webp",
    gallery: [
      "/images/properties/homas-roma/homas-roma-sala-da-pranzo.webp",
      "/images/properties/homas-roma/homas-roma-soggiorno.webp",
      "/images/properties/homas-roma/homas-roma-camera-da-letto.webp",
      "/images/properties/homas-roma/homas-roma-angolo-cottura.webp",
      "/images/properties/homas-roma/homas-roma-bagno.webp",
    ],
    startingPrice: 120,
    currency: "EUR",
    featured: false,
    active: true,
    extras: ["cleaning", "lateCheckout"],
  },
];

export const EXTRA_LABELS = {
  breakfast: { label: "Colazione", price: 12 },
  lateCheckout: { label: "Late check-out", price: 25 },
  earlyCheckin: { label: "Accesso anticipato", price: 25 },
  crib: { label: "Culla", price: 10 },
  cleaning: { label: "Pulizia aggiuntiva", price: 30 },
  transfer: { label: "Transfer", price: 45 },
  experience: { label: "Esperienza o cena", price: 60 },
  poolAccess: { label: "Ingresso piscina", price: 15 },
  petFee: { label: "Pet fee", price: 20 },
};

export const destinations = [
  { id: "laquila", name: "L’Aquila", filterCity: "L’Aquila", text: "Storia, montagna e rinascita nel cuore dell’Abruzzo.", image: "https://images.unsplash.com/photo-1610211983553-566e6fbe7319?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "velino", name: "Magliano de’ Marsi e Monte Velino", filterCity: "Magliano de’ Marsi", text: "Natura, silenzio e panorami ai piedi del Monte Velino.", image: "https://images.unsplash.com/photo-1648761264074-65371652a58e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "borghi", name: "Borghi d’Abruzzo", filterCity: "Valdevarri", text: "Dimore autentiche per riscoprire il ritmo dei piccoli centri.", image: "https://images.unsplash.com/photo-1759941030335-b8d082208f35?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
  { id: "roma", name: "Roma", filterCity: "Roma", text: "La libertà di vivere la capitale partendo da una casa tutta tua.", image: "https://images.unsplash.com/photo-1656689783030-6e26c093fd78?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" },
];

export const faq = [
  { q: "Come posso verificare la disponibilità?", a: "Seleziona la struttura, le date e il numero di ospiti nel motore di prenotazione. Il sistema mostrerà le soluzioni disponibili oppure ti permetterà di inviare una richiesta." },
  { q: "Posso prenotare direttamente?", a: "Sì. Quando il booking engine definitivo sarà collegato, potrai verificare tariffe, disponibilità e condizioni direttamente dal sito." },
  { q: "Gli orari di check-in sono uguali per tutte le strutture?", a: "No. Gli orari e le modalità di accesso possono variare. Le informazioni specifiche vengono indicate nella pagina della struttura e nella conferma di prenotazione." },
  { q: "Posso richiedere un check-in anticipato o un late check-out?", a: "Le richieste vengono valutate in base alla disponibilità della struttura e possono prevedere un costo aggiuntivo." },
  { q: "Sono ammessi animali?", a: "Dipende dalla struttura selezionata. Consulta i servizi e le regole della singola proprietà o invia una richiesta prima di prenotare." },
  { q: "Come riceverò le informazioni per il check-in?", a: "Prima dell’arrivo riceverai tutte le indicazioni necessarie tramite e-mail o messaggio, incluse le istruzioni per l’accesso." },
  { q: "Posso richiedere una fattura?", a: "Puoi indicare la necessità di ricevere un documento fiscale durante la prenotazione o contattare direttamente Martelli Rentals." },
  { q: "Quali sono le condizioni di cancellazione?", a: "Le condizioni dipendono dalla struttura e dalla tariffa scelta. Devono essere sempre visualizzate prima della conferma della prenotazione." },
];

// TODO: Add verified reviews — le recensioni qui sotto sono DEMO placeholder
export const testimonials = [
  { id: "demo1", stars: 5, text: "Recensione ospite da inserire — testo dimostrativo in attesa di feedback verificato.", name: "Nome ospite", from: "Provenienza", property: "La Terra di Gaia", date: "2025", source: "Fonte della recensione", verifiedUrl: "" },
  { id: "demo2", stars: 5, text: "Recensione ospite da inserire — testo dimostrativo in attesa di feedback verificato.", name: "Nome ospite", from: "Provenienza", property: "Costa Masciarelli", date: "2025", source: "Fonte della recensione", verifiedUrl: "" },
  { id: "demo3", stars: 4, text: "Recensione ospite da inserire — testo dimostrativo in attesa di feedback verificato.", name: "Nome ospite", from: "Provenienza", property: "Homas Roma", date: "2025", source: "Fonte della recensione", verifiedUrl: "" },
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1678902177251-7ec8fea483a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
  about: "https://images.unsplash.com/photo-1734173071981-b16ee4f9867f?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  hospitality: "https://images.unsplash.com/photo-1464306208223-e0b4495a5553?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  cta: "https://images.unsplash.com/photo-1648761264074-65371652a58e?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000",
};
